import yup from '../../../config/yup';

export const ethosReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('ethosReader'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    debug: yup.boolean(),
    apiKey: yup.string(),
    rootUrl: yup.string(),
    offset: yup.string(),
    limit: yup.string(),
    hasOffset: yup.string(),
    maxRecords: yup.number(),
    dataModelVersion: yup.string(),
    contentType: yup.string(),
    accept: yup.string(),
    acceptHeader: yup.string(),
    path: yup.string().required('Path is required'),
  }),
});
